import React, { createContext, useContext, useState, useEffect } from "react";
import { MotionConfig } from "framer-motion";
import { THEME_CONFIG } from "config/themeConfig";

/**
 * Animation mode context.
 * Three modes:
 *   "framer-motion" – full JS spring animations (default)
 *   "css"           – GPU-composited CSS @keyframes only
 *   "none"          – no animations at all
 */
const getInitialAnimationMode = () => {
  const saved = localStorage.getItem("animationMode");
  if (saved) return saved;
  return THEME_CONFIG.animationEnabled ? THEME_CONFIG.animationMode : "none";
};

const AnimationModeContext = createContext(getInitialAnimationMode());
const AnimationSetterContext = createContext(() => {});

export const AnimationProvider = ({ children }) => {
  const [animationMode, setAnimationMode] = useState(getInitialAnimationMode);

  useEffect(() => {
    localStorage.setItem("animationMode", animationMode);
    document.documentElement.setAttribute("data-animation", animationMode);
  }, [animationMode]);

  return (
    <AnimationModeContext.Provider value={animationMode}>
      <AnimationSetterContext.Provider value={setAnimationMode}>
        <MotionConfig
          reducedMotion={animationMode === "none" ? "always" : "user"}
        >
          {children}
        </MotionConfig>
      </AnimationSetterContext.Provider>
    </AnimationModeContext.Provider>
  );
};

export const useAnimationMode = () => useContext(AnimationModeContext);
export const useSetAnimationMode = () => useContext(AnimationSetterContext);

export default AnimationModeContext;
